import { PageView, PageTopBar } from "../../../components"

export const SuccessPage = ({ onNewReceiving, successMessage }) => {
  return (
    <PageView
      topMenu={
        <PageTopBar>
          <div className="text-lg font-semibold">
            ✅ Recebimento Concluído com Sucesso
          </div>
        </PageTopBar>
      }
    >
      <div className="max-w-2xl mx-auto text-center py-12 flex flex-col items-center justify-center">
        {/* Mensagem Principal */}
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          Recebimento Processado!
        </h1>
        
        <div className="text-xl text-gray-700 mb-8">
          {successMessage || 'Todos os SKUs foram validados e o recebimento foi registrado no sistema.'}
        </div>

        {/* Informação Adicional */}
        <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-8">
          <div className="text-green-800">
            <div className="font-semibold mb-2">✓ O que aconteceu agora:</div>
            <ul className="text-left space-y-1">
              <li>• Os produtos que não existiam anteriormente foram registrados no sistema</li>
              <li>• A remessa foi criada</li>
              <li>• A remessa foi faturada</li>
              <li>• Você pode consultar a remessa no histórico</li>
            </ul>
          </div>
        </div>

        {/* Botão para Novo Recebimento */}
        <button
          onClick={onNewReceiving}
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-6 rounded-lg text-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
        >
          📦 Fazer Novo Recebimento
        </button>
      </div>
    </PageView>
  )
} 